/**
 * Detecção dinâmica de plataforma (mobile vs desktop).
 * Usado para redirecionar ao app MetaMask no celular em vez de procurar extensão.
 */

/**
 * Verifica se o ambiente atual é mobile (smartphone/tablet).
 * Avaliado em tempo de execução (dinâmico).
 * @returns {boolean}
 */
export function isMobile() {
  if (typeof window === 'undefined') return false;

  const ua = window.navigator.userAgent || '';
  const hasTouch = 'maxTouchPoints' in navigator && navigator.maxTouchPoints > 0;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

  return mobileRegex.test(ua) || (hasTouch && window.innerWidth < 1024);
}

/**
 * Retorna a URL para abrir o dapp no app MetaMask (navegador in-app).
 * O MetaMask espera apenas o host (domínio), sem protocolo — URL completa pode causar tela branca.
 * @param {string} [host] - Host do dapp (default: window.location.host)
 * @returns {string}
 */
export function getMetaMaskDappDeepLink(host) {
  const dappHost = host || (typeof window !== 'undefined' ? window.location.host : '');
  if (!dappHost) return '';
  return `https://link.metamask.io/dapp/${dappHost}`;
}

/**
 * Redireciona o usuário para abrir o site no app MetaMask (mobile).
 * Útil quando não há provider (extensão) e estamos em mobile.
 */
export function openInMetaMaskApp() {
  if (typeof window === 'undefined') return;
  window.location.href = getMetaMaskDappDeepLink();
}
